import styled from '@emotion/styled'
import React, { ReactNode, useContext } from 'react'
import { Helmet } from 'react-helmet'

import Footer from 'components/Footer'
import Header from 'components/Header'
import LandingPageHeader from 'components/LandingPageHeader'
import PromoBar from 'components/PromoBar'
import { UserContext } from 'components/context/user-context'
import GlobalStyles from 'components/layouts/GlobalStyles'
import Overlay from 'components/overlay'

const LayoutContainer = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
`

interface IProps {
  children: ReactNode
  focused?: boolean
}

const Layout = ({ children, focused = false }: IProps) => {
  const { campaignData } = useContext(UserContext)
  const isToFu = campaignData?.audienceLevel === 'tofu'

  return (
    <LayoutContainer>
      <GlobalStyles />
      <Helmet>
        <meta property="og:site_name" content="Visa Kings Global" />
        <meta property="og:type" content="website" />
        <meta property="fb:page_id" content="115522518117579" />
      </Helmet>
      {isToFu ? <LandingPageHeader /> : <Header />}
      <div>{children}</div>
      <Footer />
      {!focused && !isToFu && <PromoBar />}
      <Overlay />
    </LayoutContainer>
  )
}

export default Layout
